const { populate } = require('@/functions/objects');
const { toInt, toString } = require('@/functions/transform');

/**
 * Represents a booking group returned from the API, attached to an order or an order line.
 */
class BookingGroup {
    /**
     * @type {number}
     */
    ID;

    /**
     * @type {string}
     */
    name;

    constructor(data = {}) {
        populate(this, data);
    }

    getHydrationMap() {
        return {
            ID: {
                field: ['ID', 'bookingGroupID'],
                transform: toInt,
            },
            name: toString,
        };
    }
}

module.exports = BookingGroup;
